import { english } from './en';
import { swedish } from './sv';
import { swedishGeneralConditions } from './sv-general-conditions';
import { englishGeneralConditions } from './en-general-conditions';

export const i18nMessages = (defaultLocale) => ({
  // default locale
  locale: defaultLocale,
  // translations
  messages: {
    'en-US': { ...english, ...englishGeneralConditions },
    'sv-SE': { ...swedish, ...swedishGeneralConditions },
  },
});
